module.exports = __webpack_public_path__ + "img/hungaria-header.68e54a4d.svg";